<template>
    <div class="gobills single-header">
        <secondary-header :title="lang('GoBills')" backRoute="default"></secondary-header>

        <main>
            <div class="container menu-list">
                <div class="row justify-content-center">
                    <div class="col-md-10 py-3">
                        <div class="font-weight-bold">{{ lang('E-Invoice') }}</div>
                        <div :class="{ 'is-loading': state.loading }">
                            <div v-for="transaction in transactions" class="list" :key="transaction.id">
                                <hr class="my-1">
                                <div class="font-weight-bold float-right">{{ money(transaction.amount_total) }}</div>
                                <div class="font-weight-bold">{{ transaction.created_at }}</div>
                                <div>{{ transaction.invoice_no }}</div>
                                <div class="font-weight-bold">{{ transaction.branch_name }}</div>
                                <div class="font-weight-bold">
                                    {{ transaction.customer_name }}
                                    <span v-if="transaction.customer_remark">- {{ transaction.customer_remark }}</span>
                                </div>
                                <div>{{ transaction.phone_no }}</div>
                                <div><span>{{ lang('Service') }}</span> : {{ transaction.service }}</div>
                                <div class="d-flex flex-wrap">
                                    <div>
                                        <div><span>{{ lang('Type') }}</span> : {{ transaction.type }}</div>
                                        <div><span>{{ lang('Status') }}</span> : {{ transaction.status_ui }}</div>
                                    </div>
                                    <div class="ml-auto d-flex">
                                        <button
                                            v-if="transaction.status == 'VALID'"
                                            :disabled="state.loading_share_pdf"
                                            @click="shareResource(transaction)"
                                            class="share-button-list"
                                        >
                                            <font-awesome-icon icon="share-alt" size="2x" class="m-auto"></font-awesome-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-if="(transactions.length == 0 && state.loading) || state.loading_next" class="loader text-center py-4">
                                {{ lang('loading...') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    data() {
        return {
            transactions: [],

            next_page: '',
            current_page: '',
        }
    },

    methods: {
        getResource() {
            this.$set(this.state, 'loading', true)
            axios.get(this.GLOBAL.API_BASE_URL +"einvoice/list")
                .then((response) => {
                    
                    this.transactions = response.data.data
                    this.next_page = response.data.links.next
                    this.current_page = response.data.meta.current_page

                    this.getNextTransactionPage()
                })
                .catch(error=>defaultErrorManagement(error.response))
                .finally(() => this.$set(this.state, 'loading', false))
        },

        getNextTransactionPage() {
            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight + 300 >= document.documentElement.offsetHeight

            if(this.next_page && bottomOfWindow) {
                this.$set(this.state, 'loading_next', true)
                axios.get(this.GLOBAL.API_BASE_URL +"einvoice/list?page="+ (parseFloat(this.current_page) + 1))
                    .then(response => {
                        this.transactions.push.apply(this.transactions, response.data.data)
                        this.next_page = response.data.links.next
                        this.current_page = response.data.meta.current_page

                        this.getNextTransactionPage()
                    })
                    .catch(error=>defaultErrorManagement(error.response))
                    .finally(() => this.$set(this.state, 'loading_next', false))

                this.next_page = ''
            }
        },

        shareResource(transaction) {
            if(this.isNative()) {
                window.ReactNativeWebView.postMessage("SHARE|type=gobills-pdf,resource=einvoice,resource_id="+ transaction.id +",api_token="+ localStorage.token)
            }
            else if('share' in window.navigator) {
                this.$set(this.state, 'loading_share_pdf', true)
                axios.post(this.GLOBAL.API_BASE_URL + "pdf", {
                        resource: 'einvoice',
                        resource_id: transaction.id,
                    },
                    {
                        responseType: 'blob',
                    }
                    )
                    .then((response) => {
                        var file = new File([response.data], transaction.uuid +".pdf", {type: "application/pdf"})
                        var files = [file]

                        if(navigator.canShare({ title: transaction.uuid, files })) {
                            navigator.share({ title: transaction.uuid, files })
                                .catch((err) => console.log(err))
                        }
                    })
                    .catch(error=>{
                        error.response.data.text()
                            .then((data) => {
                                error.response.data = JSON.parse(data)
                                defaultErrorManagement(error.response)
                            })
                    })
                    .finally(() => this.$set(this.state, 'loading_share_pdf', false))
            }
        },
    },

    created() {
        this.getResource()
    },

    mounted() {
        addEventListener("scroll", this.getNextTransactionPage)
    },

    beforeDestroy() {
        removeEventListener("scroll", this.getNextTransactionPage)
    }
}
</script>

<style lang="scss" scoped>
.share-button-list {
    background-color: #ff9800;
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
    color: white;
    display: flex;
    align-items: center;
    padding: 0;
    border: unset;
}
</style>